import { render } from "./OverviewProductList.vue?vue&type=template&id=5238070d"
import script from "./OverviewProductList.vue?vue&type=script&lang=js"
export * from "./OverviewProductList.vue?vue&type=script&lang=js"

import "./OverviewProductList.vue?vue&type=style&index=0&id=5238070d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__